module.exports = __webpack_public_path__ + "static/media/card-index-middle-3.6bcd50bb.jpg";